import { FrameElement } from '../../modules/frame/element.js';

export const tag = 'reihe-frame';

/**
 * Der Inhaltscontainer der Reihenseite. Das Verhalten steckt vollständig in `FrameElement`; hier bleibt
 * nur, was diesen Service betrifft: der Tag-Name und der Pfad, aus dem die dynamischen Importe der Basis
 * geladen werden.
 */
export class ReiheFrame extends FrameElement {
    static tag = tag;

    static {
        if (!customElements.get(ReiheFrame.tag)) {
            customElements.define(ReiheFrame.tag, ReiheFrame);
        }
    }

    constructor() {
        super();
        __webpack_public_path__ = `/reihe/resources/reihe-frame/`;
    }
}
